var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColoredIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.799,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#295fa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2197c6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.973 2.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.564,0A31.325,31.325,0,0,1,59.13,5.567a31.043,31.043,0,0,1-21.992,9.115A31.044,31.044,0,0,1,15.145,5.567,31.2,31.2,0,0,1,10.714,0H0A40.074,40.074,0,0,0,2.521,4.779a40.735,40.735,0,0,0,5.92,7.49,40.5,40.5,0,0,0,28.7,11.9,40.5,40.5,0,0,0,28.7-11.9,40.74,40.74,0,0,0,5.92-7.49A40.094,40.094,0,0,0,74.276,0Z",
    transform: "translate(3.483 57.073)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.972,47.589A31.133,31.133,0,0,0,62.64,18.628L47.325,33.94l-6.7,6.7-6.7-6.7L18.6,18.628a31.132,31.132,0,0,0-8.333,28.961H.6A40.716,40.716,0,0,1,19.387,6l6.955,6.955L40.621,27.235,54.9,12.956,61.854,6a41.067,41.067,0,0,1,7.49,5.923,40.614,40.614,0,0,1,11.3,35.665ZM40.621,9.484a31.3,31.3,0,0,0-5.048.408L27.767,2.086a40.651,40.651,0,0,1,25.71,0L45.668,9.892A31.292,31.292,0,0,0,40.621,9.484Z",
    transform: "translate(0 0)",
    fill: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredIcon);
export default __webpack_public_path__ + "static/media/colored-icon.531c1bd6569f50b21ba62a8864b7a92b.svg";
export { ForwardRef as ReactComponent };